<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import EventLog from 'src/components/EventLog/EventLog.svelte';

	export let id;
	export let alarm;
</script>

<SidepanelContent>
	<EventLog device={alarm} type={'device'} />
</SidepanelContent>
